import {StampgetTimeM, getTimeS} from '@/utils/date.js'
const dateFilter = (time) => {
  return StampgetTimeM(time)
}
const SdateFilter = (time) => {
  return getTimeS(time)
}

const toKeyValue = function ( arr ){
  let obj = {};
  arr.forEach(el => {
     obj[el.value+''] = el.label;
  });
  return obj;
}

export {
  dateFilter,
  SdateFilter,
  toKeyValue,
}



// WEBPACK FOOTER //
// ./src/filters/index.js